<template>
    <div>
        <i @click="topFunction" class="bi bi-arrow-up-square" id="floatBtn" title="Go to top"></i>
    </div>
</template>

<script>
export default {
    name: "GoBackTopButton",
    methods: {
        topFunction(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
    },
    mounted() {
        window.onscroll = function () {
            let floatBtn = document.getElementById("floatBtn");
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                floatBtn.style.display = "block";
            } else {
                floatBtn.style.display = "none";
            }
        }
    }
}
</script>

<style scoped>

#floatBtn {
    display: none;
    position: fixed;
    height: 50px;
    bottom: 100px;
    right: 30px;
    z-index: 99;
    font-size: 35px;
    border: none;
    outline: none;
    background-color: rgba(82, 100, 103, 0.78);
    color: white;
    cursor: pointer;
    padding: 0 3px 0 3px;
    border-radius: 4px;
}

</style>
